/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterNoteUpdateResponseModel } from '../../models/encounter-note-update-response-model';
import { EncounterUpdateNoteModel } from '../../models/encounter-update-note-model';

export interface EncounterNoteUpdatePost$Params {
      body?: EncounterUpdateNoteModel
}

export function encounterNoteUpdatePost(http: HttpClient, rootUrl: string, params?: EncounterNoteUpdatePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterNoteUpdateResponseModel>> {
  const rb = new RequestBuilder(rootUrl, encounterNoteUpdatePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<EncounterNoteUpdateResponseModel>;
    })
  );
}

encounterNoteUpdatePost.PATH = '/Encounter/NoteUpdate';
